import React from 'react'
import Button from '@mui/material/Button';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

// https://docs.sheetjs.com/#sheetjs-js-xlsx

const Download = () => {

    const fileName = 'text'
    const csvData = [
        { firstName: 'John', lastName: 'Smith' },
        { firstName: 'Joe', lastName: 'Bloggs' }
    ]

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);

        ws.A1.v = 'First Name'
        ws.B1.v = 'Last Name'

        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    return (
        <Button variant="contained" onClick={(e) => exportToCSV(csvData,fileName)}>Export</Button>
    )
}

export default Download